import { Col, ListGroup, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InviteStatusBadge from "./InviteStatusBadge";
import AccessStatus from "./AccessStatus";
import { formatDate } from "../../../../utils/DateUtils";
import IInviteRecord from "../../../../models/invite/IInviteRecord";

interface IInviteListItemProps {
    invite: IInviteRecord;
}

export const InviteListItem = (props: IInviteListItemProps) => {
    const { t } = useTranslation();
    const { invite } = props;

    return (
        <ListGroup.Item>
            <Row className="align-items-center">

                <Col xs={12} lg={3} className="mb-2 mb-lg-0">
                    <span className="d-lg-none fw-bold me-1">
                        {t("it.invite.history.table.headers.name")}:
                    </span>

                    {invite.invitee.firstName}{" "}
                    {invite.invitee.lastName}
                </Col>

                <Col xs={12} lg={3} className="mb-2 mb-lg-0">
                    <span className="d-lg-none fw-bold me-1">
                        {t("it.invite.history.table.headers.email")}:
                    </span>

                    {invite.invitee.emailAddress}
                </Col>

                <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                    <span className="d-lg-none fw-bold me-1">
                        {t("it.invite.history.table.headers.invited")}:
                    </span>

                    {formatDate(invite.requestedAt)}
                </Col>

                <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                    <span className="d-lg-none fw-bold me-1">
                        {t("it.invite.history.table.headers.status")}:
                    </span>

                    <InviteStatusBadge status={invite.status} />
                </Col>

                <Col xs={12} lg={2}>
                    <span className="d-lg-none fw-bold me-1">
                        {t("it.invite.history.table.headers.access")}:
                    </span>

                    <AccessStatus invite={invite} />
                </Col>

            </Row>
        </ListGroup.Item>
    );
};